<template>
  <div>
    <label class="col-12">
      {{ label }}
    </label>
    <div
      class="checkbox-columns"
      :class="{ 'many-items': options.length > 10 }"
      data-toggle="buttons"
    >
      <label
        v-for="(option, idx) in options"
        :key="idx"
        :for="fieldId(idx)"
        class="justify-content-right"
        style="margin-right:20px;"
      >
        <input
          type="checkbox"
          :id="fieldId(idx)"
          :name="dataName()"
          autocomplete="off"
          :value="option.val"
          v-model="itemChecked[idx]"
        />
        {{ option.label }}
        <FormFieldComponent
          v-if="option.field"
          :field="option.field"
          v-show="itemChecked.length >= idx && itemChecked[idx]"
        />
      </label>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    label: String,
    type: String,
    name: String,
    options: Array,
    subfield: Object,
    field: {
      type: Object,
      default:  () => ({})
    }
  },
  data() {
    return {
      itemChecked: [],
    };
  },
  mounted() {
    this.itemChecked.length = this.$props.options.length;
  },
  methods: {
    colsize(option) {
      if (option.field) return "col-12";
      return "col-" + parseInt(12 / this.options.length);
    },
    dataName() {
      return (this.name || "data_name_undefined") + "[]";
    },
    fieldId(idx) {
      // Generate a unique ID by replacing invalid characters in data_name
      const baseId = (this.name || "data_name_undefined")
        .replace(/\[|\]/g, "_") // Replace [ and ] with _
        // .replace(/_+/g, "_") // Replace multiple underscores with a single underscore
        .replace(/^_|_$/g, ""); // Remove leading or trailing underscores
      return `${baseId}_${idx}`;
    },
  },
};
</script>

<style>
.checkbox-columns {
  column-count: 2;
  column-gap: 20px;
}

/* For responsive design */
@media (max-width: 768px) {
  .checkbox-columns {
    column-count: 1;
  }
}

/* If you need 3 columns for more than 12 items */
.checkbox-columns.many-items {
  column-count: 3;
}

.checkbox-columns label {
  display: block;
  break-inside: avoid;
  margin-bottom: 8px;
}
</style>